import { gql } from '@apollo/client';
import { apolloClientDS } from '../../../apollo';

export const getRootCauseQuery = () => {
	const payload = `query anomaly($startDate: String!, $endDate: String!, $id: [String], $anomalyChange: [String], $type: String!, $channel: [String]) {
        anomaly(
            input: {
                attributeFilters: [
                    { 
                        name: "channel"
                        values: $channel
                    }
                    {
                            
                        attribute: $type
                        name: "id"
                        values: $id
                    }
                    {
                            
                        name: "flag"
                        values: $anomalyChange
                    }
                    {
                        name: "replenishableInstock"
                        values: "['95']"
                    }
                ]
                timeFilters: [
                    { 
                        startDate: $startDate,
                        endDate: $endDate 
                    }
                ]
            }
    
        ) {
            id
            name
            marketShare
            marketShareChng
            rootCause {
                inventoryHealth {
                    itemOosCnt
                    totalSalesImpact
                    causes {
                        edges {
                            node {
                                potentialSalesImpact
                                dimensions {
                                    wmItemNbr
                                    wmItemNm
                                }
                            }
                        }
                    }
                } 
                pricing {
                    priceCntInc
                    priceCntDec
                    totalSalesImpact
                    causes {
                        edges {
                            node {
                                potentialSalesImpact
                                status
                                changeDt
                                dimensions {
                                    wmItemNbr
                                    wmItemNm
                                }
                            }
                        }
                    }
                }
                assortment {
                    addedItemCnt
                    removedItemCnt
                    totalSalesImpact
                    causes {
                        edges {
                            node {
                                status
                                changeDt
                                potentialSalesImpact
                                dimensions {
                                    wmItemNbr
                                    wmItemNm
                                }
                            }
                        }
                    }
                }
                pod {
                    traitedStoreCntInc
                    traitedStoreCntDec
                    totalSalesImpact
                    causes {
                        edges {
                            node {
                                potentialSalesImpact
                                dimensions {
                                    wmItemNbr
                                    wmItemNm
                                }
                            }
                        }
                    }
                }
            }
        }
    }`;
	return payload;
};

export const generateRootCauseQuery = (payload) => {
	const queryStr = gql`
		${getRootCauseQuery()}
	`;

	const query = queryStr;

	const obj = {
		...payload,
		channel: ['STORE'],
		anomalyChange: [payload.anomalyChange],
	};

	return apolloClientDS.query({
		query,
		context: {
			headers: {
				'x-Apollo-operation-name': 'anomaly',
			},
		},
		variables: obj,
	});
};
